export default __webpack_public_path__ + "static/marquee3-min-b109fe2c00fe7f09305b7797c86a8e0d.jpg";